module.exports = __webpack_public_path__ + "assets/img/pine grove 59m.23802ec7.jpg";